import { SET_IMAGE, SET_FORMAT, SET_DIMENSION, SET_POSITION, SET_AVIABLE, SET_IS_CHANGED, SET_ROTATED } from '../constants/canvasConstants';

export const canvasInitState = {
    image: '',
    format: 'image/jpeg',
    height: 0,
    width: 0,
    x: 0,
    y: 0,
    isAvaible: false,
    isChanged: false,
    rotationAngle: 0,
};

const canvasReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_IMAGE:
            return {
                ...state,
                image: action.image
            }
        case SET_FORMAT:
            return {
                ...state,
                format: action.format
            }
        case SET_DIMENSION:
            return {
                ...state,
                height: action.height,
                width: action.width,
            }

        case SET_POSITION:
            return {
                ...state,
                x: action.x,
                y: action.y
            }
        case SET_AVIABLE:
            return {
                ...state,
                isAvaible: action.isAvaible,
            }
        case SET_IS_CHANGED:
            return {
                ...state,
                isChanged: action.isChanged,
            }
        case SET_ROTATED:
            return {
                ...state,
                rotationAngle: action.rotationAngle,
            }
        case "CANVAS_SET_FLIP_VERTICAL":
            return {
                ...state,
                isFlipVertical: action.isFlipVertical,
            }


        case "CANVAS_SET_FLIP_HORIZONTAL":
            return {
                ...state,
                isFlipHorizontal: action.isFlipHorizontal,
            }

        case "CANVAS_SET_SAVE_PROPORTIONS":
            return {
                ...state,
                cropIsSaveProportions: action.cropIsSaveProportions,
            }
        case "CANVAS_SET_CROP_DIMENSIONS":
            return {
                ...state,
                cropDimensions: action.cropDimensions,
            }

        case "CANVAS_SET_VALIDATION":
            return {
                ...state,
                cropValidation: action.cropValidation,
            }

        default:
            return { ...state };
    }
};

export default canvasReducer;